import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} Startseite`,
    languageButtonLabel: `Sprache`,
    languageModalTitle: `Sprache wählen`,
    languageModalCloseLabel: `Sprachmenü schließen`,
  },
  languageOptions: {
    'en-US': {
      label: `Englisch`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Englisch (Kenia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Englisch (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Englisch (Singapur)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugiesisch`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Deutsch`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spanisch`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Französisch`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italienisch`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Niederländisch`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Nordisch & Baltisch`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japanisch`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koreanisch`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarin`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantonesisch`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thailändisch`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Farsi`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russisch`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabisch`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marokkanisches Arabisch`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Sprache wählen`,
    closeLabel: `Sprachmenü schließen`,
  },
  languageHint: (ctx) => `Wechsle in über ${ctx.localesCount}+ Sprachversionen.`,
  readPagePrompt: ({languageLabel}) => `Lies diese Seite auf ${languageLabel}.`,
};
